import { defineMessages } from "react-intl";

const baseId = "t.components.status.";

export default defineMessages({
  APPROVAL: {
    id: baseId + "APPROVAL",
    defaultMessage: "APPROVAL",
  },
  COMPLETED: {
    id: baseId + "COMPLETED",
    defaultMessage: "COMPLETED",
  },
  ERROR: {
    id: baseId + "ERROR",
    defaultMessage: "ERROR",
  },
  EXECUTION: {
    id: baseId + "EXECUTION",
    defaultMessage: "EXECUTION",
  },
  _EXECUTION: {
    id: baseId + "EXECUTION",
    defaultMessage: "EXECUTION",
  },
  REFUSED: {
    id: baseId + "REFUSED",
    defaultMessage: "REFUSED",
  },
  PENDING: {
    id: baseId + "PENDING",
    defaultMessage: "PENDING",
  },
  WAITING: {
    id: baseId + "WAITING",
    defaultMessage: "WAITING",
  },
  IN_EXECUTION: {
    id: baseId + "IN_EXECUTION",
    defaultMessage: "IN EXECUTION",
  },
  SCHEDULED: {
    id: baseId + "SCHEDULED",
    defaultMessage: "SCHEDULED",
  },
  IN_PROGRESS: {
    id: baseId + "IN_PROGRESS",
    defaultMessage: "IN PROGRESS",
  },
  STARTING: {
    id: baseId + "STARTING",
    defaultMessage: "STARTING",
  },
  NOT_ASSIGNED: {
    id: baseId + "NOT_ASSIGNED",
    defaultMessage: "NOT ASSIGNED",
  },
  TAKING_CHARGE: {
    id: baseId + "TAKING_CHARGE",
    defaultMessage: "TAKING CHARGE",
  },
  OPEN: {
    id: baseId + "OPEN",
    defaultMessage: "OPEN CHARGE",
  },
  CLOSE: {
    id: baseId + "CLOSE",
    defaultMessage: "CLOSE CHARGE",
  },
  CLOSED: {
    id: baseId + "CLOSED",
    defaultMessage: "CLOSED CHARGE",
  },
  PENDING_VALIDATION: {
    id: baseId + "PENDING_VALIDATION",
    defaultMessage: "PENDING VALIDATION CHARGE",
  },
  PENDING_EXECUTION: {
    id: baseId + "PENDING_EXECUTION",
    defaultMessage: "PENDING EXECUTION CHARGE",
  },
  MIXED: {
    id: baseId + "MIXED",
    defaultMessage: "MIXED CHARGE",
  },
  ND: {
    id: baseId + "ND",
    defaultMessage: "ND",
  },
  CESSATO: {
    id: baseId + "CESSATO",
    defaultMessage: "CESSATO",
  },
  CESSATO_SECURITY: {
    id: baseId + "CESSATO_SECURITY",
    defaultMessage: "CESSATO SECURITY",
  },
  SCADUTO: {
    id: baseId + "SCADUTO",
    defaultMessage: "SCADUTO",
  },
  IN_SERVIZIO: {
    id: baseId + "IN_SERVIZIO",
    defaultMessage: "IN SERVIZIO",
  },
  IN_VALIDAZIONE: {
    id: baseId + "IN_VALIDAZIONE",
    defaultMessage: "IN VALIDAZIONE",
  },
  NON_IN_SERVIZIO: {
    id: baseId + "NON_IN_SERVIZIO",
    defaultMessage: "NON IN SERVIZIO",
  },
  BLOCCATO_SECURITY: {
    id: baseId + "BLOCCATO_SECURITY",
    defaultMessage: "BLOCCATO SECURITY",
  },
  ACTIVE: {
    id: baseId + "ACTIVE",
    defaultMessage: "ACTIVE",
  },
  INACTIVE: {
    id: baseId + "INACTIVE",
    defaultMessage: "INACTIVE",
  },
  RETRY: {
    id: baseId + "RETRY",
    defaultMessage: "RETRY",
  },
});
